var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocus4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2V42C2.5 43.3261 3.02678 44.5979 3.96447 45.5355C4.90215 46.4732 6.17392 47 7.5 47H47.5M35 7H40C41.3807 7 42.5 8.11929 42.5 9.5V34.5C42.5 35.8807 41.3807 37 40 37H35C33.6193 37 32.5 35.8807 32.5 34.5V9.5C32.5 8.11929 33.6193 7 35 7ZM15 14.5H20C21.3807 14.5 22.5 15.6193 22.5 17V34.5C22.5 35.8807 21.3807 37 20 37H15C13.6193 37 12.5 35.8807 12.5 34.5V17C12.5 15.6193 13.6193 14.5 15 14.5Z",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus4);
export default __webpack_public_path__ + "static/media/focus-4.a6b3618c7a0b4221f86745e0fdf2cc98.svg";
export { ForwardRef as ReactComponent };